// extracted by mini-css-extract-plugin
export default {"searchbar":"SearchBar_searchbar__xBucJ","img":"SearchBar_img__E7vuJ","input":"SearchBar_input__bIy50","label":"SearchBar_label__4uG7W"};